import { render } from "./Costume.vue?vue&type=template&id=f752d652&scoped=true"
import script from "./Costume.vue?vue&type=script&lang=js"
export * from "./Costume.vue?vue&type=script&lang=js"

import "./Costume.vue?vue&type=style&index=0&id=f752d652&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f752d652"]])

export default __exports__